import { redirect, createFileRoute } from '@tanstack/react-router'
import { getPlayerSession } from '@/features/player-session'

export const Route = createFileRoute('/logout')({
  beforeLoad: async () => {
    const playerSession = await getPlayerSession()

    if (playerSession.isUserLoggedIn) {
      return playerSession.logout({ redirectTo: 'home' })
    }

    return redirect({ to: '/' })
  },
})
